import BillingCodesForm from '@/components/forms/BillingCodesForm.vue'
import BlacklistsForm from '@/components/forms/BlacklistsForm.vue'
import CarrierPoliciesForm from '@/components/forms/CarrierPoliciesForm.vue'
import CarriersForm from '@/components/forms/CarriersForm.vue'
import CountriesForm from '@/components/forms/CountriesForm.vue'
import MenuItemList from '@/components/forms/menu/MenuItemList.vue'
import MenuPreviewForm from '@/components/forms/menu/MenuPreviewForm.vue'
import MessagesForm from '@/components/forms/MessagesForm.vue'
import PermissionsForm from '@/components/forms/PermissionsForm.vue'
import ProductKeywordsForm from '@/components/forms/ProductKeywordsForm.vue'
import ProductsForm from '@/components/forms/ProductsForm.vue'
import ProvidersForm from '@/components/forms/ProvidersForm.vue'
import RolesForm from '@/components/forms/RolesForm.vue'
import RolesPermissionsForm from '@/components/forms/RolesPermissionsForm.vue'
import ShortcodesForm from '@/components/forms/ShortcodesForm.vue'
import UserPermissionsForm from '@/components/forms/UserPermissionsForm.vue'
import UserRolesForm from '@/components/forms/UserRolesForm.vue'
import UsersForm from '@/components/forms/UsersForm.vue'
import ReportCategoriesForm from '../../components/forms/ReportCategoriesForm.vue'
import ReportDatasourcesForm from '../../components/forms/ReportDatasourcesForm.vue'
import ReportChartTypesForm from '../../components/forms/ReportChartTypesForm.vue'
import ReportForm from '../../views/admin/Report/ReportForm.vue'
import ReportRolesForm from '../../views/admin/Report/ReportRolesForm.vue'

export default [
    {
        path: 'forms/users-permissions/:action/:id?',
        name: 'UserPermissionsForm',
        meta: {
            auth: 'admin',
            routePermissions: 'user.edit'
        },
        component: UserPermissionsForm
    },
    {
        path: 'forms/users-roles/:action/:id?',
        name: 'UserRolesForm',
        meta: {
            auth: 'admin',
            routePermissions: 'user.edit'
        },
        component: UserRolesForm
    },
    {
        path: 'forms/users/:action/:id?',
        name: 'UsersForm',
        meta: {
            auth: 'admin',
            routePermissions: ['user.edit', 'user.create']
        },
        component: UsersForm
    },
    {
        path: 'forms/roles-permissions/:action/:id?',
        name: 'RolesPermissionsForm',
        meta: {
            auth: 'admin',
            routePermissions: 'role.edit'
        },
        component: RolesPermissionsForm
    },
    {
        path: 'forms/permissions/:action/:id?',
        name: 'PermissionsForm',
        meta: {
            auth: 'admin',
            routePermissions: ['permission.edit', 'permission.create']
        },
        component: PermissionsForm
    },
    {
        path: 'forms/roles/:action/:id?',
        name: 'RolesForm',
        meta: {
            auth: 'admin',
            routePermissions: ['role.edit', 'role.create']
        },
        component: RolesForm
    },
    {
        path: 'forms/menu-preview/:action/:id?',
        name: 'MenuPreviewForm',
        meta: {
            auth: 'admin',
            routePermissions: ['menu.edit', 'menu.create']
        },
        component: MenuPreviewForm
    },
    {
        path: 'forms/menu-item/:parent/:action?/:id?/:parentItem?',
        name: 'MenuItemForm',
        meta: {
            auth: 'admin',
            routePermissions: ['menu-item.edit', 'menu-item.create']
        },
        component: MenuItemList
    },
    {
        path: 'forms/countries/:action/:id?',
        name: 'CountriesForm',
        meta: {
            auth: 'admin',
            routePermissions: ['country.edit', 'country.create']
        },
        component: CountriesForm
    },
    {
        path: 'forms/carriers/:action/:id?',
        name: 'CarriersForm',
        meta: {
            auth: 'admin',
            routePermissions: ['carrier.edit', 'carrier.create']
        },
        component: CarriersForm
    },
    {
        path: 'forms/carrier-policies/:action/:id?',
        name: 'CarrierPoliciesForm',
        meta: {
            auth: 'admin',
            routePermissions: ['carrier-policy.edit', 'carrier-policy.create']
        },
        component: CarrierPoliciesForm
    },
    {
        path: 'forms/providers/:action/:id?',
        name: 'ProvidersForm',
        meta: {
            auth: 'admin',
            routePermissions: ['provider.edit', 'provider.create']
        },
        component: ProvidersForm
    },
    {
        path: 'forms/shortcodes/:action/:id?',
        name: 'ShortcodesForm',
        meta: {
            auth: 'admin',
            routePermissions: ['shortcode.edit', 'shortcode.create']
        },
        component: ShortcodesForm
    },
    {
        path: 'forms/billing-code/:action/:id?',
        name: 'BillingCodesForm',
        meta: {
            auth: 'admin',
            routePermissions: ['billing-code.edit', 'billing-code.create']
        },
        component: BillingCodesForm
    },
    {
        path: 'forms/products/:action/:id?',
        name: 'ProductsForm',
        meta: {
            auth: 'admin',
            routePermissions: ['product.edit', 'product.create']
        },
        component: ProductsForm
    },
    {
        path: 'forms/product-keywords/:action/:id?',
        name: 'ProductKeywordsForm',
        meta: {
            auth: 'admin',
            routePermissions: ['product-keyword.edit', 'product-keyword.create']
        },
        component: ProductKeywordsForm
    },
    {
        path: 'forms/messages/:action/:id?',
        name: 'MessagesForm',
        meta: {
            auth: 'admin',
            routePermissions: ['message.edit', 'message.create']
        },
        component: MessagesForm
    },
    {
        path: 'forms/blacklists/:action/:id?',
        name: 'BlacklistsForm',
        meta: {
            auth: 'admin',
            routePermissions: ['blacklist.edit', 'blacklist.create']
        },
        component: BlacklistsForm
    },
    {
        path: 'forms/categories/:action/:id?',
        name: 'ReportcategoriesForm',
        meta: {
            auth: 'admin',
            routePermissions: ['report-category.edit', 'report-category.create']
        },
        component: ReportCategoriesForm
    },
    {
        path: 'forms/datasources/:action/:id?',
        name: 'ReportdatasourcesForm',
        meta: {
            auth: 'admin',
            routePermissions: ['report-datasource.edit', 'report-datasource.create']
        },
        component: ReportDatasourcesForm
    },
    {
        path: 'forms/chart-types/:action/:id?',
        name: 'ReportcharttypesForm',
        meta: {
            auth: 'admin',
            routePermissions: ['report-chart-types.edit', 'report-chart-types.create']
        },
        component: ReportChartTypesForm
    },
    {
        path: 'forms/reports/:action/:id?',
        name: 'ReportsForm',
        meta: {
            auth: 'admin',
            routePermissions: ['report.edit', 'report.create']
        },
        component: ReportForm
    },
    {
        path: 'forms/reports-roles/:action/:id?',
        name: 'ReportRolesForm',
        meta: {
            auth: 'admin',
            routePermissions: 'report.add-roles'
        },
        component: ReportRolesForm
    }
]
